/*
    this component returns a divider with a small left arrow in the middle
*/
import type { FC } from "react";
import styled from "styled-components";
import { colorsPalettes } from "@similarweb/styles";

const { carbon } = colorsPalettes;

const DividerWrapper = styled.div`
    width: 10px;
    height: 100%;
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: center;
`;

interface IDivider {
    height?: string;
}

const Divider: FC<IDivider> = ({ height = "332" }) => {
    return (
        <DividerWrapper data-automation="Divider">
            <svg
                width="12"
                height="100%"
                viewBox={`0 0 12 ${height}`}
                fill="none"
                xmlns="http://www.w3.org/2000/svg"
                preserveAspectRatio="none"
            >
                <path
                    d={`M11.5 0L11.5 124L1.49999 156L11.5 188L11.5 ${height}`}
                    stroke={`${carbon[50]}`}
                />
            </svg>
        </DividerWrapper>
    );
};

export default Divider;
